export default __webpack_public_path__ + "static/media/keju-logo.3edfbe35.png";